<template>
  <div class="page-wrapper">
    <Contacts @tab="switchTab" v-if="tab_switch == 'contacts'"></Contacts>
  </div>
</template>
<script>
import Contacts from "./Contacts.vue";
export default {
  components: {
    Contacts,
  },
  data: () => ({
    tab_switch: "contacts",
  }),
  watch: {
    "$route.params.tab"(tab) {
      this.tab_switch = tab;
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "ads", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>

